import React from "react";
import { Sparkle20Filled } from "@fluentui/react-icons";
import { useWebChatContext } from "./WebChatContext";
import { useWebChatStyles } from "./WebChatStyles";

export const WebChatToggleButton: React.FC = () => {
  const { isOpen, setIsOpen } = useWebChatContext();
  const styles = useWebChatStyles();

  if (isOpen) return null;

  return (
    <button
      className={styles.toggleButton}
      onClick={() => setIsOpen(true)}
      aria-label="Open chat"
      data-testid="webchat-toggle"
    >
      <span className={styles.toggleButtonIcon} aria-hidden="true">
        <Sparkle20Filled />
      </span>
      <span className={styles.toggleButtonText}>Dining Assistant</span>
    </button>
  );
};
